import IamApi from "api/IamApi";
import { useBiller } from "hooks";
import _ from "lodash";
import React, { useEffect } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import routing from "routing";
import { Spinner } from "kubra-ux-forge";
import { getDomain } from "utilities/helper";
import { useDispatch, useSelector } from "react-redux";
import { getDeviceFingerprint } from "selectors/appState";
import { setPayableSession } from "actions/payableSessionActions";

export const PayableCsrDirectLanding = () => {
  const dispatch = useDispatch();

  // TODO: find out how is the fingerprint provided for CSR direct landing initiated payments?
  const fingerprint = useSelector(getDeviceFingerprint);

  const { getBiller } = useBiller();
  const biller = getBiller();

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const domain = getDomain();

    const getPaymentIntentId = () => {
      const match = matchPath(
        routing.payableCsrDirectLanding.read(":paymentIntentId"),
        location.pathname
      );
      return _.get(match, ["params", "paymentIntentId"]);
    };

    const paymentIntentId = getPaymentIntentId();

    if (!paymentIntentId) {
      throw new Error("Failed to retrieve payment intent ID from path");
    }

    IamApi.ezpay
      .getPayableCsrDirectLanding(biller.spaceKrn, paymentIntentId, domain)
      .then((payableSession) => {
        dispatch(setPayableSession(payableSession));
        navigate(routing.payableDashboard.index());
      })
      .catch((error) => {
        console.error(error);
        navigate(routing.index());
      });
    // This useEffect should only run once, on initial render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "0 auto",
            height: "50vh",
            backgroundColor: "white",
            width: "75vw",
            justifyContent: "center",
            borderRadius: "24px",
            verticalAlign: "middle",
          }}
        >
          <Spinner size="large" variant="primary" />
        </div>
      </div>
    </>
  );
};

export default PayableCsrDirectLanding;
